import { EHR_CURRENT_CHANNEL_SORT_BY_FILTER, useStorage } from '@/libs/storage'
import { sortByMap } from '@/models/channels'

export default () => ({
  newChats: undefined,
  ongoingChats: undefined,
  activeChannels: undefined,
  followUpChannels: undefined,
  mentionChannels: undefined,
  archivedChannels: undefined,
  currentPage: 0,
  currentFilters: {
    tags: [],
    status: [],
    channelPersonId: undefined
  },
  currentSortBy: getCurrentSortBy(),
  newChatsListener: null
})

/**
 * Check if exist a current sort saved on local storage
 * If exist returns the sort saved
 * If dosen't exist returns the fist sort mapped
 * @returns sort object
 */
const getCurrentSortBy = () => {
  const { getItem } = useStorage(EHR_CURRENT_CHANNEL_SORT_BY_FILTER)
  const currentSortByStorage = getItem()
  if (currentSortByStorage) {
    return sortByMap.find(sort => sort.type === currentSortByStorage)
  }
  return sortByMap[0]
}
